export { InputPhoneComponent } from './input-phone.component';
export { InputPhoneSize } from './types';
export { inputPhoneValidator, inputPhoneFormValidator } from './validators';
